import wpAjax from '../helpers/axios';
import { resetFormMessages, doFormSubmissionActions } from '../helpers/formHelpers';
import { isOverEighteen } from './ageGate';

const submitSignupForm = () => {
	const form = document.querySelector('.js-atreemo-form');

	if (form) {
		form.addEventListener('submit', async (e) => {
			e.preventDefault();

			form.classList.add('is-faded');

			resetFormMessages(form);

			// Collect form data
			const formData = new FormData(form);
			formData.append('action', 'ajax_submit_signup_form');
			// for (const pair of formData.entries()) {
			// console.log(`${pair[0]} = ${pair[1]}`);
			// }

			// Check if user is over eighteen
			const dob = form.querySelector('input[name="atreemo_dob"]');
			if (!isOverEighteen(dob.value)) {
				doFormSubmissionActions(form, { status: 'under-eighteen' });
				return false;
			}

			// Do ajax call func here
			let data = false;
			await wpAjax
				.post('', formData)
				.then((res) => {
					data = res.data;
				})
				.catch((error) => {
					console.log(error);
					doFormSubmissionActions(form, { status: 'error' });
				});

			if (data.status === 'already-played') {
				doFormSubmissionActions(form, { status: 'already-played' });
				return false;
			}

			setTimeout(() => {
				// console.log(data);
				doFormSubmissionActions(form, data);
				form.classList.remove('opacity-50');
			}, 1000);
		});
	}
};

submitSignupForm();
